import { useQuery, useMutation } from '@tanstack/react-query';
import { queryClient } from '@/shared/services/queryClient';
import { systemSettingsApi } from '../services/systemSettingsApi';

export const useSystemSettings = (group?: string) => {
  return useQuery({
    queryKey: ['system-settings', group ?? 'all'],
    queryFn: () => systemSettingsApi.getAll(group),
  });
};

export const useUpdateSystemSetting = () => {
  return useMutation({
    mutationFn: ({ key, value }: { key: string; value: string }) =>
      systemSettingsApi.update(key, value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['system-settings'] });
    },
  });
};
